import { FilterOperationTypes } from "./interfaces";

export type FilterType = string | string[];

export interface generateFilterTypeReturn {
  type: FilterType;
  values: any[] | any;
  operation: FilterOperationTypes;
  index: any[];
  table: string;
}

export interface generateFilterType {
  type: FilterType;
  values: any[];
  operation: FilterOperationTypes;
  index: any[];
  table?: string;
  forceOperation?: boolean;
  values_in?: any[];
  values_not_in?: any[];
}

export type generateFilterFunction = (
  type: FilterType,
  values: any[],
  operation: FilterOperationTypes,
  index: any[],
  table?: string,
  forceOperation?: boolean,
  values_in?: any[],
  values_not_in?: any[]
) => generateFilterTypeReturn;

export const generateFilter: generateFilterFunction = (
  type,
  values,
  operationType,
  index,
  table = "filter",
  forceOperation = false,
  values_in = undefined,
  values_not_in = undefined
) => {
  const operation = forceOperation
    ? operationType
    : Array.isArray(values) && values.length === 2
    ? "between"
    : operationType;
  return {
    type: type === "item_id" ? undefined : type,
    values,
    operation,
    index,
    table: table === "undefined" ? undefined : table,
    values_in,
    values_not_in,
  };
};
